import { useEffect, useState } from "react"
import { useParams } from "react-router"
// import classnames from "classnames"

import { useCheckList } from "./CheckListContext"

import AddCheckListItem from "./AddCheckListItem"
import BreadCrumbs from "../Breadcrumbs"
import CheckListItem from "./CheckListItem"
import ReadOnlyField from "./ReadOnlyField"
import SaveChecklistButton from "./SaveChecklistButton"
import TextInput from "./TextInput"

import { getChecklistBC, getPhaseBC, getSubPhaseBC } from "../urls"

const SubPhase = (props) => {
    const params = useParams()
    const {phaseIdx, subPhaseIdx} = params
    const { hier, getRec } = useCheckList()
    const [ phase, setPhase] = useState(null)
    const [ctx, setCtx] = useState(null)
    const [rec, setRec] = useState(null)

    useEffect(
        () => {
            const _phaseCtx = hier[phaseIdx]
            setPhase(getRec(_phaseCtx))
            const _ctx = hier[phaseIdx].subPhases[subPhaseIdx]
            setCtx(_ctx)
        }, [getRec, phaseIdx, subPhaseIdx, hier]
    )

    useEffect(
        () => {
            !!ctx && setRec(getRec(ctx))
        }, [ctx, getRec]
    )


    if (!rec) {
        return (<div>loading...</div>)
    }
    return (
        <div className="sub-phase">
            <BreadCrumbs
                crumbs={[
                    getChecklistBC(params),
                    getPhaseBC(params, phase.label),
                    getSubPhaseBC(params, rec.label)
                ]}
            />
            <SaveChecklistButton />
            <div>
                <b>SubSection</b>
                <table>
                    <colgroup>
                        <col span="1" style={{width: "15%"}} />
                        <col span="1" style={{width: "85%"}} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td
                                style={{
                                    fontWeight: "bold",
                                    paddingRight: "10px",
                                    textAlign: "right"
                                }}
                            >
                                ID
                            </td>
                            <td><ReadOnlyField rec={rec} fld="id" /></td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    fontWeight: "bold",
                                    paddingRight: "10px",
                                    textAlign: "right"
                                }}
                            >
                                Label
                            </td>
                            <td><TextInput rec={rec} fld="label" unique={true} /></td>
                        </tr>
                    </tbody>
                </table>

                <fieldset className="top-level">
                    <legend>CheckList Items</legend>
                    {!ctx.items
                        ? <div>No checklist items yet.</div>
                        : <table>
                            <colgroup>
                                <col span="1" style={{ width: "5%" }} />
                                <col span="1" style={{ width: "10%" }} />
                                <col span="1" style={{ width: "15%" }} />
                                <col span="1" style={{ width: "20%" }} />
                                <col span="1" style={{ width: "20%" }} />
                                <col span="1" style={{ width: "5%"  }} />
                                <col span="1" style={{ width: "20%" }} />
                                <col span="1" style={{ width: "5%" }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Type</th>
                                    <th>ID</th>
                                    <th>Label</th>
                                    <th>Abbr Label</th>
                                    <th>Graded</th>
                                    <th>Feedback</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {ctx.items.map((item, i) =>
                                    <CheckListItem
                                        key={item.id}
                                        ctx={item}
                                        index={i}
                                        asTable={true}
                                    />
                                )}
                            </tbody>
                        </table>
                    }
                    <hr />
                    <AddCheckListItem
                        index={rec._ctx.lastIndex + 1}
                        phase={rec.phase}
                        subPhase={rec._ctx.id}
                        parentID={rec._ctx.id}
                    />
                </fieldset>
            </div>
            <SaveChecklistButton />
        </div>
    )
}


export default SubPhase